import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Route} from '../../../enum/route';
import {selectUserId} from '../../../store/user/selectors/user.selectors';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../../store/user/reducers/user.reducer';

@Component({
    selector: 'app-lob-modal',
    templateUrl: './lob-modal.component.html',
    styleUrls: ['./lob-modal.component.scss'],
    standalone: false
})
export class LobModalComponent {

  @Input() showLobModal: boolean = false;
  @Output() showLobModalChange = new EventEmitter<boolean>();

  userId$ = this.userStore.select(selectUserId);

  constructor(private readonly router: Router,
              public userStore: Store<UserAppState>) { }

  closeLobModal() {
    this.showLobModal = false;
    this.showLobModalChange.emit(false);
    this.router.navigate(['/' + Route.INSERATE]);
  }

  navigateToEditLobs() {
    this.showLobModal = false;
    this.showLobModalChange.emit(false);
    this.userId$.subscribe(id => this.router.navigate([Route.USER_PAGE, id], {queryParams: {previousRoute: 'lobModal'}}));
  }
}
